<section class="pbw-panel">
  <h2 class="pbs-title">Lo que hay que decidir</h2>
  <p class="pbs-lead">
    <ng-container *ngIf="state.autoResolvedCount">
      <strong>{{ state.autoResolvedCount }} pago(s)</strong> ya tienen destino: su cliente tiene un solo arrendamiento
      activo y el motor los resuelve solo.
    </ng-container>
    Abajo están los que no: clientes con varios arrendamientos —hay que elegir a cuáles va el dinero y en qué orden— y
    clientes sin ninguno activo.
  </p>

  <div class="pbs-loading" *ngIf="loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Cargando los arrendamientos de los clientes…</span>
  </div>

  <div class="pbs-notice" *ngIf="!loading && pendientes">
    <i class="fa-solid fa-hand-pointer" aria-hidden="true"></i>
    <div>
      <strong>Falta decidir {{ pendientes }} pago(s)</strong>
      Abre cada uno con «Elegir» y confirma el reparto. Si alguno no debe aplicarse ahora, sácalo del lote: se queda
      registrado y lo aplicas después desde su arrendamiento.
    </div>
  </div>

  <div class="pbs-notice is-danger" *ngIf="!loading && state.orphanRows.length">
    <i class="fa-solid fa-unlink" aria-hidden="true"></i>
    <div>
      <strong>{{ state.orphanRows.length }} pago(s) sin arrendamiento activo</strong>
      Su dinero queda registrado y disponible. No se pueden aplicar desde aquí: sácalos del lote para seguir.
    </div>
  </div>

  <ul class="pbd-list">
    <li *ngFor="let r of rows" class="pbd-item" [class.is-off]="r.excluded" [class.is-open]="abierto === r.paymentId">
      <div class="pbd-row">
        <div class="pbd-who">
          <strong>{{ r.clientName }}</strong>
          <span class="pbs-hint">{{ r.trackingKey }} · {{ r.date ? (r.date | date: 'dd/MM/yyyy') : '—' }}</span>
        </div>

        <div class="pbd-amount">{{ r.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>

        <div class="pbd-dest">
          <span [class.pbd-pending]="!state.isDecided(r) && !r.excluded">{{ destino(r) }}</span>
        </div>

        <div class="pbd-acts">
          <button
            pButton
            type="button"
            [label]="abierto === r.paymentId ? 'Cerrar' : 'Elegir'"
            class="p-button-sm p-button-outlined"
            *ngIf="necesitaElegir(r) && !r.excluded"
            (click)="alternar(r)"
          ></button>
          <button
            pButton
            type="button"
            [label]="r.excluded ? 'Devolver al lote' : 'Sacar del lote'"
            [icon]="r.excluded ? 'fa-solid fa-rotate-left' : 'fa-solid fa-ban'"
            class="p-button-sm p-button-text p-button-secondary"
            (click)="alternarExclusion(r)"
          ></button>
        </div>
      </div>

      <!-- El selector de reparto que ya existe. Las cifras que pinta están cortadas a la FECHA DEL
           PAGO, no a hoy: es lo que el motor va a cobrar. -->
      <div class="pbd-selector" *ngIf="abierto === r.paymentId && !r.excluded">
        <app-lease-distribution-selector
          [leases]="r.allocatable"
          [amount]="r.amount"
          [asOf]="r.date"
          (distributionChange)="onDistributionChange(r, $event)"
        ></app-lease-distribution-selector>
      </div>
    </li>
  </ul>

  <!-- Puede quedar vacía en un lote recuperado: sus filas parecen huérfanas hasta que llegan los
       arrendamientos, y algunas resultan tener uno solo. -->
  <div class="pbs-notice" *ngIf="!loading && !rows.length">
    <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
    <div>
      <strong>No queda nada que decidir</strong>
      Los {{ state.applicableRows.length }} pago(s) del lote tienen un destino único. Sigue al impacto.
    </div>
  </div>

  <div class="pbs-actions">
    <button pButton type="button" label="Salir" class="p-button-text p-button-secondary pbs-left" (click)="onExit.emit()"></button>
    <span class="pbs-hint pbs-note">{{ state.decidedRows.length }} de {{ state.applicableRows.length }} pago(s) con destino</span>
    <button pButton type="button" label="Volver al registro" icon="fa-solid fa-chevron-left" class="p-button-outlined" (click)="onBack.emit()"></button>
    <button pButton type="button" label="Ver el impacto" icon="fa-solid fa-chevron-right" iconPos="right" [disabled]="!puedeSeguir" (click)="onDone.emit()"></button>
  </div>
</section>
